// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TopBox_Container__6dvC9 {
    background-color: #353839;
    background-color: #fff;
    margin: 0; 
    width: 100vh;  
}

.TopBox_Longboxl__9u2gh {
    font-family: "Playfair";
}

.TopBox_Longboxr__2k95a {
    font-family: "Playfair";
}

.TopBox_Shot__MxWp0 {
    color: #F5F5F5;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 1);
    font-family: "Cinzel";
}

.TopBox_TitleT__LwJD1 {
    color: #00d1ff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 1);
    font-family: "Playball";
    border-bottom: 1px solid #c1f1f7;
}

.TopBox_Second__p0eVR {
    color: #c1f1f5;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.6);
    font-weight: 700;
}

.TopBox_Title__inl0e {
    color: #F5F5F5;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.6);
}

.TopBox_Title2__QF-hY {
    color: #F5F5F5;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 1);
}

.TopBox_Title3__cBvzp {
    color: #F5F5F5;
}

.TopBox_RegBoxSign__OaQ\\+K {
    background-color: #353839;
    margin: 0;  
    width: 100%; 
    background-color: #000;
}

.TopBox_RegBox__emsQp {
    background-color: #353839;
    margin: 0;  
    width: 100%; 
    background-color: #000;
}

.TopBox_Black__wJfFc {
    background-color: #000;
}

.TopBox_Titlebox__K5VNK {
	background-color: #3b444b;
    background-color: #39606e;
	margin-bottom: 15px;
	margin-top: 15px;
    min-height: 120px;
}

.TopBox_Titlebox2__mA\\+1G {
	background-color: #3b444b;
    border: 1px solid #39606e;
	margin-bottom: 15px;
	margin-top: 15px;
    min-height: 100px;
}

.TopBox_BlueBody__4WyOU {
    background-color: rgb(235, 250, 250);
}

.TopBox_Longboxl__9u2gh {
    color: rgb(255, 6, 6);
    margin-top: 30px;
}

.TopBox_Longboxr__2k95a {
    color: rgb(255, 6, 6);
    margin-top: 10px;
}

.TopBox_Longboxl__9u2gh p {
    color: rgb(255, 6, 6);
    margin-bottom: 0;
}

.TopBox_Longboxr__2k95a p {
    color: rgb(255, 6, 6);
    margin-bottom: 0;
}

.TopBox_Doorbox__kX77e{
 max-height: 160px;
}

.TopBox_SmallPanel__4kDoY {
    height: 100%;
    width: 5px;
    object-fit: cover;
}

/* .SmallPanel {
    height: 120px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
} */

.TopBox_PadLeft1__YToIA {
    padding-left: 10px;
}

.TopBox_Door__QjEv1 {
    height: 100%;
}

/* @media screen and (min-width: 1100px) {
    .Titlebox {
        width: 60%;
    }
} */

@media screen and (max-width: 600px) {
    .TopBox_Titlebox__K5VNK {
    min-height: 100px;
}

    h3 {
    font-size: 1.20rem !important;
  }

  h2 {
    font-size: 1.25rem !important;
  }

  h1 {
    font-size: 1.25rem !important;
  }
    /* .Title {
        font-size: 1.50em;
    }

    .Title2 {
        font-size: 1.50em;
    } */

    /* .Title3 {
        font-size: 1.25em;
    } */
}

@media screen and (max-width: 380px) {
    .TopBox_Second__p0eVR {
    font-size: .9rem !important;
  }

    /* .Title {
        font-size: 1.50em;
    }

    .Title2 {
        font-size: 1.50em;
    } */

    /* .Title3 {
        font-size: 1.25em;
    } */
}`, "",{"version":3,"sources":["webpack://./src/styles/TopBox.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;CACC,yBAAyB;IACtB,yBAAyB;CAC5B,mBAAmB;CACnB,gBAAgB;IACb,iBAAiB;AACrB;;AAEA;CACC,yBAAyB;IACtB,yBAAyB;CAC5B,mBAAmB;CACnB,gBAAgB;IACb,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,iBAAiB;AACrB;;AAEA;;;;;GAKG;;AAEH;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;GAIG;;AAEH;IACI;IACA,iBAAiB;AACrB;;IAEI;IACA,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;IACE;;;;;;OAMG;;IAEH;;OAEG;AACP;;AAEA;IACI;IACA,2BAA2B;EAC7B;;IAEE;;;;;;OAMG;;IAEH;;OAEG;AACP","sourcesContent":[".Container {\n    background-color: #353839;\n    background-color: #fff;\n    margin: 0; \n    width: 100vh;  \n}\n\n.Longboxl {\n    font-family: \"Playfair\";\n}\n\n.Longboxr {\n    font-family: \"Playfair\";\n}\n\n.Shot {\n    color: #F5F5F5;\n    text-shadow: 2px 2px 2px rgba(0, 0, 0, 1);\n    font-family: \"Cinzel\";\n}\n\n.TitleT {\n    color: #00d1ff;\n    text-shadow: 2px 2px 2px rgba(0, 0, 0, 1);\n    font-family: \"Playball\";\n    border-bottom: 1px solid #c1f1f7;\n}\n\n.Second {\n    color: #c1f1f5;\n    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.6);\n    font-weight: 700;\n}\n\n.Title {\n    color: #F5F5F5;\n    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.6);\n}\n\n.Title2 {\n    color: #F5F5F5;\n    text-shadow: 2px 2px 2px rgba(0, 0, 0, 1);\n}\n\n.Title3 {\n    color: #F5F5F5;\n}\n\n.RegBoxSign {\n    background-color: #353839;\n    margin: 0;  \n    width: 100%; \n    background-color: #000;\n}\n\n.RegBox {\n    background-color: #353839;\n    margin: 0;  \n    width: 100%; \n    background-color: #000;\n}\n\n.Black {\n    background-color: #000;\n}\n\n.Titlebox {\n\tbackground-color: #3b444b;\n    background-color: #39606e;\n\tmargin-bottom: 15px;\n\tmargin-top: 15px;\n    min-height: 120px;\n}\n\n.Titlebox2 {\n\tbackground-color: #3b444b;\n    border: 1px solid #39606e;\n\tmargin-bottom: 15px;\n\tmargin-top: 15px;\n    min-height: 100px;\n}\n\n.BlueBody {\n    background-color: rgb(235, 250, 250);\n}\n\n.Longboxl {\n    color: rgb(255, 6, 6);\n    margin-top: 30px;\n}\n\n.Longboxr {\n    color: rgb(255, 6, 6);\n    margin-top: 10px;\n}\n\n.Longboxl p {\n    color: rgb(255, 6, 6);\n    margin-bottom: 0;\n}\n\n.Longboxr p {\n    color: rgb(255, 6, 6);\n    margin-bottom: 0;\n}\n\n.Doorbox{\n max-height: 160px;\n}\n\n.SmallPanel {\n    height: 100%;\n    width: 5px;\n    object-fit: cover;\n}\n\n/* .SmallPanel {\n    height: 120px;\n    padding-left: 10px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n} */\n\n.PadLeft1 {\n    padding-left: 10px;\n}\n\n.Door {\n    height: 100%;\n}\n\n/* @media screen and (min-width: 1100px) {\n    .Titlebox {\n        width: 60%;\n    }\n} */\n\n@media screen and (max-width: 600px) {\n    .Titlebox {\n    min-height: 100px;\n}\n\n    h3 {\n    font-size: 1.20rem !important;\n  }\n\n  h2 {\n    font-size: 1.25rem !important;\n  }\n\n  h1 {\n    font-size: 1.25rem !important;\n  }\n    /* .Title {\n        font-size: 1.50em;\n    }\n\n    .Title2 {\n        font-size: 1.50em;\n    } */\n\n    /* .Title3 {\n        font-size: 1.25em;\n    } */\n}\n\n@media screen and (max-width: 380px) {\n    .Second {\n    font-size: .9rem !important;\n  }\n\n    /* .Title {\n        font-size: 1.50em;\n    }\n\n    .Title2 {\n        font-size: 1.50em;\n    } */\n\n    /* .Title3 {\n        font-size: 1.25em;\n    } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `TopBox_Container__6dvC9`,
	"Longboxl": `TopBox_Longboxl__9u2gh`,
	"Longboxr": `TopBox_Longboxr__2k95a`,
	"Shot": `TopBox_Shot__MxWp0`,
	"TitleT": `TopBox_TitleT__LwJD1`,
	"Second": `TopBox_Second__p0eVR`,
	"Title": `TopBox_Title__inl0e`,
	"Title2": `TopBox_Title2__QF-hY`,
	"Title3": `TopBox_Title3__cBvzp`,
	"RegBoxSign": `TopBox_RegBoxSign__OaQ+K`,
	"RegBox": `TopBox_RegBox__emsQp`,
	"Black": `TopBox_Black__wJfFc`,
	"Titlebox": `TopBox_Titlebox__K5VNK`,
	"Titlebox2": `TopBox_Titlebox2__mA+1G`,
	"BlueBody": `TopBox_BlueBody__4WyOU`,
	"Doorbox": `TopBox_Doorbox__kX77e`,
	"SmallPanel": `TopBox_SmallPanel__4kDoY`,
	"PadLeft1": `TopBox_PadLeft1__YToIA`,
	"Door": `TopBox_Door__QjEv1`
};
export default ___CSS_LOADER_EXPORT___;
